// extracted by mini-css-extract-plugin
export default {"table_row":"TableRow_table_row__5zby2"};